// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"696":"1c600182","702":"6dc574b1","787":"794568ed","811":"4ea2e3bd"}[chunkId] + ".chunk.js";
};